import { connect } from 'react-redux';
import { get } from 'lodash';
import moment from 'moment-timezone';
import React, { useState, useEffect } from 'react';

import { getClientStoreNameTranslation } from '@commons/utils/translations';

import { getClientInfo } from '@selectors/client';
import { getPrevHorizon } from '@selectors/featureProps';

import { usePeriodDatePickerState } from '@hooks/usePeriodDatePickerState';

import ExportModalWithStoresAndPeriod from '@commons/ExportModalWithStoresAndPeriod';

import { Container } from './styledComponents';

const MAX_NB_OF_DAYS_FOR_RANGE = 365;

const ForecastsExportModal = ({
  prevHorizon,
  exportStartDate,
  setExportStartDate,
  exportEndDate,
  setExportEndDate,
  selectedStoresForExport,
  setSelectedStoresForExport,
  setIsExportModalButtonDisabled,
  filteredStores,
  groups,
  selectedGroups,
  setSelectedGroups,
  client: { storeName, defaultTimezone },
}) => {
  const [maxFutureDate, setMaxFutureDate] = useState(null);
  const periodPickerState = usePeriodDatePickerState(
    exportStartDate,
    exportEndDate,
    defaultTimezone,
  );

  const clientStoreName = getClientStoreNameTranslation(storeName, true);

  const futurePrevHorizon = get(prevHorizon, 'future', 0);

  useEffect(() => {
    const currentMaxFutureDate = moment
      .tz(defaultTimezone)
      .startOf('day')
      .add(futurePrevHorizon, 'day');

    setMaxFutureDate(currentMaxFutureDate);
  }, []);

  useEffect(() => {
    if (!periodPickerState.startDate) {
      return;
    }

    const selectedStartDate = moment(periodPickerState.startDate)
      .tz(defaultTimezone)
      .startOf('day');

    const todayWithFuturePrevHorizon = moment()
      .tz(defaultTimezone)
      .startOf('day')
      .add(futurePrevHorizon, 'day');

    // If selectedDate is less than 365 days in the past we want to set the maxFutureDate to today + prevHorizon
    if (todayWithFuturePrevHorizon.diff(selectedStartDate, 'days') < MAX_NB_OF_DAYS_FOR_RANGE) {
      setMaxFutureDate(todayWithFuturePrevHorizon);
      return;
    }

    setMaxFutureDate(selectedStartDate.add(MAX_NB_OF_DAYS_FOR_RANGE, 'days'));
  }, [periodPickerState.startDate]);

  useEffect(() => {
    setExportStartDate(periodPickerState.startDate);
    setExportEndDate(periodPickerState.endDate);

    if (
      !selectedStoresForExport.length ||
      !periodPickerState.startDate ||
      !periodPickerState.endDate
    ) {
      setIsExportModalButtonDisabled(true);
      return;
    }

    setIsExportModalButtonDisabled(false);
  }, [selectedStoresForExport, periodPickerState.startDate, periodPickerState.endDate]);

  return (
    <Container>
      <ExportModalWithStoresAndPeriod
        clientStoreName={clientStoreName}
        defaultTimezone={defaultTimezone}
        filteredStores={filteredStores}
        groups={groups}
        maxFutureDate={maxFutureDate}
        periodPickerState={periodPickerState}
        selectedGroups={selectedGroups}
        selectedStores={selectedStoresForExport}
        setSelectedGroups={setSelectedGroups}
        setSelectedStores={setSelectedStoresForExport}
      />
    </Container>
  );
};

const mapStateToProps = (state) => ({
  client: getClientInfo(state.baseReducer.user),
  prevHorizon: getPrevHorizon(state.baseReducer.userRights),
});

export default connect(mapStateToProps)(ForecastsExportModal);
